import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import QuickFilter from "../../pages/products/QuickFilter";
import { ALL_CATEGORIES_LIMIT, toCategoryOptions } from "../../pages/products/categoryFilter";
import { getArtforms } from "../../Store/artform/actions";
import { getCategory } from "../../Store/category/actions";
import { getSubCategorys } from "../../Store/actions";
import { getTypes } from "../../Store/type/actions";
import { getWeaveType } from "../../Store/weave-type/actions";
type Option = { label: string; value: string };
const toOptions = (res: any): Option[] => (res?.data?.docs || []).map((row: any) => ({ label: row.name, value: row._id }));
const ProductPickerFilters = ({ filters, onChange, onReset, trailingActions, additionalFilters, getArtforms, getTypes, getCategory, getSubCategorys, getWeaveType }: any) => {
  const filtersRef = useRef(filters);
  filtersRef.current = filters;
  const [artformOptions, setArtformOptions] = useState<Option[]>([]);
  const [typeOptions, setTypeOptions] = useState<Option[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<Array<Option & { byName?: boolean }>>([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState<Option[]>([]);
  const [weaveTypeOptions, setWeaveTypeOptions] = useState<Option[]>([]);
  const getArtformData = (data?: any) => {
    getArtforms({ offset: 0, limit: 10, artformName: data?.value }, (res: any) =>
      setArtformOptions(toOptions(res))
    );
  };
  const getTypesData = (data?: any) => {
    getTypes(
      {
        offset: 0,
        limit: 10,
        artFormId: filtersRef.current?.artform?.value || data?.artform,
        typeName: data?.value,
      },
      (res: any) => setTypeOptions(toOptions(res))
    );
  };
  const getCategoryData = (data?: any) => {
    const typeId = filtersRef.current?.type?.value || data?.type;
    getCategory(
      {
        offset: 0,
        limit: typeId ? 10 : ALL_CATEGORIES_LIMIT,
        typeId,
        artformId: typeId ? filtersRef.current?.artform?.value || data?.artform : undefined,
        categoryName: data?.value,
      },
      (res: any) => setCategoryOptions(toCategoryOptions(res?.data?.docs, !typeId))
    );
  };
  const getSubCategoryData = (data?: any) => {
    getSubCategorys(
      {
        offset: 0,
        limit: 10,
        categoryId: filtersRef.current?.category?.value || data?.category,
        typeId: filtersRef.current?.type?.value || data?.type,
        artformId: filtersRef.current?.artform?.value || data?.artform,
        subCategoryName: data?.value,
      },
      (res: any) => setSubcategoryOptions(toOptions(res))
    );
  };
  const getWeaveTypeData = (data?: any) => {
    getWeaveType(
      {
        offset: 0,
        limit: 10,
        weaveTypeName: data?.value,
        subCategoryId: filtersRef.current?.subCategory?.value || data?.subCategory,
        categoryId: filtersRef.current?.category?.value || data?.category,
        typeId: filtersRef.current?.type?.value || data?.type,
        artformId: filtersRef.current?.artform?.value || data?.artform,
      },
      (res: any) => setWeaveTypeOptions(toOptions(res))
    );
  };

  const autoFocus = (data: any) => {
    if (data?.name === "artform") getArtformData();
    else if (data?.name === "type") getTypesData();
    else if (data?.name === "category") getCategoryData();
    else if (data?.name === "subCategory") getSubCategoryData();
    else if (data?.name === "weaveType") getWeaveTypeData();
  };

  const handleOnInputChange = (type: any) => {
    const value = type?.value || "";
    if (type?.name === "artform" && (value.length >= 2 || value.length === 0)) {
      getArtformData({ value });
    }
    if (type?.name === "type" && (value.length >= 2 || value.length === 0)) {
      getTypesData({ value, artform: filtersRef.current?.artform?.value });
    }
    if (type?.name === "category" && (value.length >= 2 || value.length === 0)) {
      getCategoryData({
        value,
        artform: filtersRef.current?.artform?.value,
        type: filtersRef.current?.type?.value,
      });
    }
    if (type?.name === "subCategory" && (value.length >= 2 || value.length === 0)) {
      getSubCategoryData({
        value,
        artform: filtersRef.current?.artform?.value,
        type: filtersRef.current?.type?.value,
        category: filtersRef.current?.category?.value,
      });
    }
    if (type?.name === "weaveType" && (value.length >= 2 || value.length === 0)) {
      getWeaveTypeData({
        value,
        artform: filtersRef.current?.artform?.value,
        type: filtersRef.current?.type?.value,
        category: filtersRef.current?.category?.value,
        subCategory: filtersRef.current?.subCategory?.value,
      });
    }
  };

  return <QuickFilter hideCreateProduct compact filters={filters} filtersData={filters}
    additionalFilters={additionalFilters}
    handleOnchangeFilter={onChange} handleResetData={onReset} handleKeyDown={() => undefined}
    getAllData={() => onChange({ name: "q", value: filters.q || "" })}
    autoFocus={autoFocus} handleOnInputChange={handleOnInputChange} handleDateRange={() => undefined}
    artformOptions={artformOptions} typeOptions={typeOptions} categoryOptions={categoryOptions}
    subcategoryOptions={subcategoryOptions} weaveTypeOptions={weaveTypeOptions} trailingActions={trailingActions} />;
};
export default connect(null, { getArtforms, getTypes, getCategory, getSubCategorys, getWeaveType })(ProductPickerFilters);
